import React, { useState } from 'react';
import { Plus, Pencil, Trash2, X, Save, Tag } from 'lucide-react';
import { useApp } from '../../context/AppContext';
import AdminLayout from '../../components/AdminLayout';

const blank = { id: '', discount: '₹100 OFF', text: '', code: '' };

const AdminOffers = () => {
  const { offers, upsertOffer, deleteOffer } = useApp();
  const [editing, setEditing] = useState(null);

  const openNew = () => setEditing({ ...blank, id: 'off_' + Date.now(), isNew: true });
  const openEdit = (o) => setEditing({ ...o, isNew: false });

  const save = () => {
    if (!editing.text.trim() || !editing.code.trim()) { alert('Text and code are required'); return; }
    const { isNew, ...o } = editing;
    upsertOffer(o);
    setEditing(null);
  };

  const remove = (id) => {
    if (window.confirm('Delete this offer?')) deleteOffer(id);
  };

  return (
    <AdminLayout title="Offers & Coupons">
      <div className="flex items-center justify-between mb-5">
        <p className="text-sm text-neutral-600">Manage promotional offers shown on customer home.</p>
        <button onClick={openNew} className="inline-flex items-center gap-2 bg-[#2E7D32] hover:bg-[#276D2A] text-white px-4 py-2 rounded-lg font-semibold text-sm transition-colors">
          <Plus className="w-4 h-4" /> Add Offer
        </button>
      </div>

      <div className="grid grid-cols-1 md:grid-cols-3 gap-3">
        {offers.map((o) => (
          <div key={o.id} className="bg-gradient-to-br from-[#E8F5E9] to-[#F1F8E9] border border-[#C8E6C9] rounded-xl p-4">
            <div className="flex items-start justify-between">
              <div className="w-12 h-12 rounded-lg bg-[#2E7D32] text-white text-xs font-bold flex items-center justify-center px-1 text-center leading-tight">
                {o.discount}
              </div>
              <div className="flex gap-1">
                <button onClick={() => openEdit(o)} className="w-8 h-8 rounded-full bg-white shadow-sm flex items-center justify-center hover:shadow transition-shadow">
                  <Pencil className="w-3.5 h-3.5" />
                </button>
                <button onClick={() => remove(o.id)} className="w-8 h-8 rounded-full bg-white shadow-sm flex items-center justify-center text-red-600 hover:bg-red-50 transition-colors">
                  <Trash2 className="w-3.5 h-3.5" />
                </button>
              </div>
            </div>
            <p className="mt-3 font-bold text-neutral-900">{o.text}</p>
            <p className="mt-2 text-xs text-neutral-700">Code: <span className="font-mono font-bold text-[#2E7D32] bg-white px-2 py-0.5 rounded border border-dashed border-[#2E7D32]">{o.code}</span></p>
          </div>
        ))}
        {offers.length === 0 && (
          <div className="col-span-full text-center py-16">
            <Tag className="w-10 h-10 text-neutral-300 mx-auto" />
            <p className="mt-3 text-neutral-500">No offers yet</p>
          </div>
        )}
      </div>

      {editing && (
        <div className="fixed inset-0 bg-black/50 z-50 flex items-center justify-center p-4">
          <div className="bg-white rounded-2xl w-full max-w-md shadow-2xl">
            <div className="p-5 border-b border-neutral-200 flex items-center justify-between">
              <h3 className="font-bold text-lg">{editing.isNew ? 'New Offer' : 'Edit Offer'}</h3>
              <button onClick={() => setEditing(null)} className="text-neutral-500 hover:text-neutral-900"><X className="w-5 h-5" /></button>
            </div>
            <div className="p-5 space-y-4">
              <Field label="Discount badge (e.g. ₹100 OFF)" value={editing.discount} onChange={(v) => setEditing({ ...editing, discount: v })} />
              <Field label="Offer description" value={editing.text} onChange={(v) => setEditing({ ...editing, text: v })} />
              <Field label="Coupon code" value={editing.code} onChange={(v) => setEditing({ ...editing, code: v.toUpperCase() })} />
            </div>
            <div className="p-5 border-t border-neutral-200 flex justify-end gap-2">
              <button onClick={() => setEditing(null)} className="px-4 py-2 rounded-lg text-sm font-semibold text-neutral-700 hover:bg-neutral-100 transition-colors">Cancel</button>
              <button onClick={save} className="inline-flex items-center gap-2 px-4 py-2 rounded-lg bg-[#2E7D32] hover:bg-[#276D2A] text-white text-sm font-semibold transition-colors">
                <Save className="w-4 h-4" /> Save
              </button>
            </div>
          </div>
        </div>
      )}
    </AdminLayout>
  );
};

const Field = ({ label, value, onChange }) => (
  <div>
    <label className="text-xs font-semibold text-neutral-700">{label}</label>
    <input type="text" value={value} onChange={(e) => onChange(e.target.value)}
      className="mt-1 w-full px-3 py-2 text-sm rounded-lg border border-neutral-200 focus:outline-none focus:border-[#2E7D32]" />
  </div>
);

export default AdminOffers;
